import React, { useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import { useRequestData, usePrefs } from 'wsm-common-data';
import { ErrorBoundary } from 'wsm-error-boundary';
import logger from 'ws-scripts/modules/logger';
import InputDisplayButton from '../components/InputDisplayButton';
import SearchForm from '../components/SearchForm';
import SearchButton from '../components/SearchButton';
import SearchModal from '../components/SearchModal';
import TrackingEvent from '../util/trackingEvent';
import SpeechRecognitionWrapper from '../util/SpeechRecognitionWrapper';
import { g } from '../global-constants';

import '../global-sass/main.scss';

const Widget = () => {
	const { windowId, widgetName } = useRequestData();
	const { display, hideWidgetOnPages } = usePrefs();
	const {
		widgetData: { pageAlias }
	} = useSelector(state => state);

	const { triggerTrackingEvent } = new TrackingEvent(windowId, widgetName);
	const speechRecognitionWrapper = new SpeechRecognitionWrapper();
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const inputRef = useRef();

	const openModal = () => {
		setModalIsOpen(true);
	};
	const closeModal = () => {
		setModalIsOpen(false);
	};

	if (
		hideWidgetOnPages
			.split(',')
			.some(aliasToHideOn => aliasToHideOn.trim() === pageAlias)
	) {
		return null;
	}

	const searchForm = (
		<SearchForm
			inputRef={inputRef}
			triggerTrackingEvent={triggerTrackingEvent}
			speechRecognitionWrapper={speechRecognitionWrapper}
			closeModal={closeModal}
		/>
	);

	const searchModal = (
		<SearchModal
			isOpen={modalIsOpen}
			onClose={closeModal}
			inputRef={inputRef}
			triggerTrackingEvent={triggerTrackingEvent}
		>
			{searchForm}
		</SearchModal>
	);

	let displayMarkup = null;

	switch (display) {
		case g.INPUT:
			displayMarkup = (
				<React.Fragment>
					<InputDisplayButton
						openModal={openModal}
						triggerTrackingEvent={triggerTrackingEvent}
						speechRecognitionWrapper={speechRecognitionWrapper}
					/>
					{searchModal}
				</React.Fragment>
			);
			break;
		case g.EMBEDDED:
			displayMarkup = searchForm;
			break;
		case g.DISABLED:
		case g.BUTTON:
		case g.NAVIGATION:
		default:
			displayMarkup = (
				<React.Fragment>
					<SearchButton
						onClick={event => {
							event.preventDefault();
							openModal();
						}}
					/>
					{searchModal}
				</React.Fragment>
			);
	}

	return (
		<ErrorBoundary
			errorHandler={(error, errorInfo) => {
				const newError = new Error(
					`Encountered an error in ws-site-text-search.\n${error}`
				);
				newError.originalError = error;
				newError.originalStackTrace = errorInfo.componentStack;
				logger.error(`${newError}\n${newError.originalStackTrace}`);
			}}
		>
			{displayMarkup}
		</ErrorBoundary>
	);
};

export default Widget;
